export default "__VITE_ASSET__Boim4TKx__"